import { Link } from "react-router-dom";
import Grain from "@/components/Grain";
import { ArrowLeft } from "lucide-react";

const CONTACT_EMAIL = "contact@gotoasktasha.com";

const H = ({ children }) => (
  <h2 className="mt-12 mb-4 font-serif text-2xl font-semibold text-cream md:text-3xl">{children}</h2>
);
const P = ({ children }) => (
  <p className="mb-4 font-sans text-base font-light leading-relaxed text-cream/75">{children}</p>
);

export default function Terms() {
  return (
    <div className="dark relative min-h-screen bg-ink text-cream" data-testid="terms-page">
      <Grain />
      <div className="container-tasha py-24">
        <Link
          to="/"
          className="mb-10 inline-flex items-center gap-2 font-sans text-sm uppercase tracking-widest text-gold hover:text-gold-light"
        >
          <ArrowLeft size={16} /> Back
        </Link>
        <span className="overline">Legal</span>
        <h1 className="mt-4 font-serif text-4xl font-semibold leading-tight text-cream md:text-6xl">
          Terms &amp; <span className="font-script text-gold">Conditions</span>
        </h1>
        <p className="mt-5 font-sans text-sm text-cream/60" data-testid="terms-operator-note">
          #AskTasha is operated by <span className="text-cream/85">Sister to Sister Staffing, LLC</span>.
        </p>
        <p className="mt-2 font-sans text-sm text-cream/50">
          Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
        </p>

        <div className="mt-10 max-w-3xl">
          <P>
            Welcome to #AskTasha, operated by Sister to Sister Staffing, LLC ("Company",
            "we", "our"). By registering for the class series, requesting the Launch
            Blueprint, or otherwise using this website, you agree to these Terms &amp;
            Conditions.
          </P>

          <H>Educational Purpose Only</H>
          <P>
            All content on this site and in the class series is provided for general
            educational and informational purposes only. Nothing on this site is legal,
            medical, financial, or professional advice. You should consult a qualified
            professional before making decisions related to your specific situation.
          </P>

          <H>Class Registration &amp; Attendance</H>
          <P>
            The Home Health Care Agency Class Series is offered live on Zoom, Thursdays at
            7:00 PM EST, free of charge. Registration secures your seat but does not create any
            contractual relationship beyond attendance in the class you registered for. Class
            content, schedule, and format may change without notice.
          </P>

          <H>SMS Messaging Terms</H>
          <P>
            Users opt in to SMS only by checking an optional, unchecked consent box on the
            registration form at gotoasktasha.com. The checkbox reads: "Yes, send me class
            reminder texts from #AskTasha. About 1–2 msgs per class week. Msg &amp; data rates
            may apply. Reply HELP for help, STOP to opt out." Consent is not a condition of
            registration.
          </P>
          <P>
            Message frequency: <span className="text-cream/90">about 1–2 messages per class
            week</span>. Messages include class reminders, Zoom join links, and schedule
            changes. <span className="text-cream/90">Message and data rates may apply.</span>
          </P>
          <P>
            You can opt out at any time by replying <span className="text-cream">STOP</span> to any message. Reply <span className="text-cream">HELP</span> for
            support.
          </P>
          <P>
            Carriers are not liable for delayed or undelivered messages.
          </P>

          <H>Intellectual Property</H>
          <P>
            All content, materials, and resources — including the Launch Blueprint PDF, class
            slides, and site copy — are the property of #AskTasha and are protected by
            applicable intellectual property laws. You may not redistribute, resell, or reproduce
            materials without written permission.
          </P>

          <H>User Conduct</H>
          <P>
            You agree to use this site and attend classes respectfully and lawfully. We reserve
            the right to remove any attendee at our discretion.
          </P>

          <H>Third-Party Services</H>
          <P>
            The class is delivered via Zoom, emails via Resend, and SMS via Twilio. Your use of
            those services is also governed by their respective terms.
          </P>

          <H>Disclaimer &amp; Limitation of Liability</H>
          <P>
            This site and the class series are provided "as is" without warranties of any kind.
            To the fullest extent permitted by law, #AskTasha shall not be liable for any
            damages arising out of your use of the site, participation in the class series, or
            reliance on any information provided.
          </P>

          <H>Changes</H>
          <P>
            We may update these Terms from time to time. Continued use of the site after updates
            constitutes acceptance of the revised Terms.
          </P>

          <H>Contact</H>
          <P>
            Questions? Email{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-gold">{CONTACT_EMAIL}</a>.
          </P>
        </div>
      </div>
    </div>
  );
}
